module.exports = __webpack_public_path__ + "img/Tessellate29.716a5aab.jpg";